export function canvasProfileSettingsUrl(baseUrl: string): string | null {
  try {
    const url = new URL(baseUrl.trim());
    if (url.protocol !== 'https:' || url.username || url.password) return null;
    url.pathname = '/profile/settings';
    url.search = '';
    url.hash = '';
    return url.toString();
  } catch {
    return null;
  }
}
